module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-1.49f8b479.png";